import { API_BASE } from "../api/api";

const REDIRECT_URI = `${API_BASE}/auth/shopify`;
const CLIENT_ID = import.meta.env.VITE_SHOPIFY_CLIENT_ID;
const SCOPES = [
  "read_products",
  "write_products",
  "read_orders",
  "write_orders",
  "read_all_orders",
  "read_customers",
  "write_customers",
  "read_inventory",
  "write_inventory",
  "read_analytics",
  "read_reports",
  "write_marketing_events",
  "read_marketing_events",
  "read_files",
  "read_themes",
  "read_draft_orders",
  "read_content",
  "write_content",
  "unauthenticated_read_content",
  "write_files",
  "write_themes",
  "write_theme_code",
  "read_legal_policies",
  "read_returns",
  "read_markets",
  "read_locales",
].join(",");

export const buildShopifyInstallUrl = () => {
  const state = Math.random().toString(36).substring(2);
  const redirect = encodeURIComponent(REDIRECT_URI);
  return `https://shopify.com/admin/oauth/authorize?client_id=${CLIENT_ID}&scope=${SCOPES}&redirect_uri=${redirect}&state=${state}`;
};
